import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReset = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 5.25C10.0031 5.25 8.20664 6.11836 6.96914 7.5H8.625C9.24727 7.5 9.75 8.00273 9.75 8.625C9.75 9.24727 9.24727 9.75 8.625 9.75H4.125C3.50273 9.75 3 9.24727 3 8.625V4.125C3 3.50273 3.50273 3 4.125 3C4.74727 3 5.25 3.50273 5.25 4.125V6.04805C6.89883 4.18125 9.31055 3 12 3C16.9711 3 21 7.02891 21 12C21 16.9711 16.9711 21 12 21C8.94141 21 6.23789 19.4742 4.61367 17.1434C4.25859 16.6336 4.38164 15.934 4.89141 15.5754C5.40117 15.2168 6.10078 15.3434 6.45937 15.8531C7.68281 17.6039 9.70781 18.7465 12 18.7465C15.7266 18.7465 18.75 15.723 18.75 11.9965C18.75 8.26992 15.7266 5.25 12 5.25Z",
		fill: "currentColor"
	})
});
export default SvgReset;
